import Cookies from 'jscookie';

document.addEventListener('DOMContentLoaded', function() {

    const initScript = function() {

        const scripts = document.querySelectorAll('script[type="text/plain"]');

        const drawInlineScript = function (content){
            const scriptEl = document.createElement('script');
            scriptEl.type = 'text/javascript';
            scriptEl.textContent = content;
            document.body.append(scriptEl);
        }

        const drawHtml = function (content){
            const htmlEl = document.createElement('div');
            htmlEl.innerHTML = content;
            document.body.append(htmlEl);
        }

        scripts.forEach((script) => {
            const type = script.getAttribute('data-type');

            if (type == "js") {
                drawInlineScript(script.innerHTML);
                script.remove();
            } else if (type == 'html') {
                drawHtml(script.innerHTML);
                script.remove();
            }

        });
    }

    function render(){
        const app = window.app || {};

        function drawButtons(){
            return `
                <div class="c-cookie-bar__buttons">
                    <button type="button" class="c-cookie-bar__ok">Zgadzam się</button>
                    <button type="button" class="c-cookie-bar__cancel">Innym razem</button>
                </div>
            `;
        }

        function drawText(){
            return `
            <div class="c-cookie-bar__content">
                ${app.cookie}
            </div>`
        }

        const el = document.createElement('div');
        el.classList.add('c-cookie-bar');

        el.innerHTML = "<div class='c-cookie-bar__wrapper'>" + drawText() + drawButtons() + "</div>";

        el.querySelector('.c-cookie-bar__ok').addEventListener('click',()=>{
            el.remove();
            global.document.cookie = 'cookie-msg=1;';
            initScript();
        })
        el.querySelector('.c-cookie-bar__cancel').addEventListener('click',()=>{
            el.remove();
        })

        document.body.append(el);
    }

    let fromcookie = Cookies.get('cookie-msg');
    if (fromcookie == undefined)
        render();
    else if (fromcookie != 1)
        render();
    else
        initScript();

});
